// extracted by mini-css-extract-plugin
module.exports = {"button":"AuthForm_button__SAdqO","resetPasswordLink":"AuthForm_resetPasswordLink__IXW8f","resetPassword":"AuthForm_resetPassword__FzUg2"};